import { Calendar } from "lucide-react";

export default function StickyCTA({ visible, onBook }) {
    if (!visible) return null;
    return (
        <div
            className="fixed left-1/2 -translate-x-1/2 bottom-4 sm:bottom-6 z-40 pointer-events-none"
            data-testid="sticky-cta"
        >
            <div className="pointer-events-auto flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2.5 sm:py-3 rounded-full bg-[#0A0A0A] border border-white/15 shadow-2xl">
                <span className="hidden sm:inline text-xs uppercase tracking-widest text-zinc-400 pl-1.5">
                    Tier 1 demo
                </span>
                <button
                    onClick={onBook}
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1FA8FF] text-white text-sm font-semibold hover:bg-[#0C84D4]"
                    data-testid="sticky-book-demo"
                >
                    <Calendar className="w-4 h-4" />
                    Book a demo
                </button>
            </div>
        </div>
    );
}
